import { Observable } from 'rxjs';
import {IdAndAlias, LocalUser, UserWithEmplId} from '../types';

export abstract class UserService {
	public abstract config(): Promise<null>;
	public abstract getAvatarUrl(userId: number): string;
	public abstract getAvatarUrlAsync(userId: number) : Observable<string>;
	public abstract getInitialsAvatarUrl(userId: number): Observable<string>;
	public abstract search(nameFragment: string, max: number, includeDeleted: boolean): Promise<UserWithEmplId[]>;
	public abstract getAllLocal(): Promise<LocalUser[]>;
	public abstract importFromDirectoryIfNecessary(userId: number): void;
	public abstract spoofUser(userId: number): Promise<unknown>;
	public abstract unspoofUser(): Promise<unknown>;
	public abstract getUserIdAliasMap(): Promise<IdAndAlias[]>;
}
